import React from "react";
import MenuOptions from "../menu-options/MenuOptions";
import {
  EmailShareBtn,
  FBShareBtn,
  TelegramShareBtn,
  TwitterShareBtn
} from "dv-social-share";
import ENVIRONMENT_VAR from "../../model/const/env/env.const";
import { useLoggedUser } from "@/shared/store/auth";
import styled from "@emotion/styled";
import { IconButton } from "@mui/material";
import WhatsAppIcon from "@icons-rf/whatsapp-square.svg?react";

interface IMenuSocialProps {
  children: React.ReactNode;
  propertyType: string;
  bussinesType: string;
  sector: string;
  propertyId: string;
  slug?: string;
}

const MenuSocial = (props: IMenuSocialProps) => {
  const { userLogged } = useLoggedUser();

  const formattedPropertyType = props?.propertyType
    .replaceAll("/", "-o-")
    .replaceAll(" ", "-")
    .replace(/-o--+/g, "-o-")
    .replace(/--o-+/g, "-o-")

    .toLowerCase();
  const data = {
    url: `${ENVIRONMENT_VAR.REMAX_DOMAIN}/propiedad/${formattedPropertyType}/${props.propertyId}?referer=${userLogged?.userData?.people_id}`,
    title: `${props?.propertyType.replaceAll("/", "-o-")} en ${
      props?.bussinesType
    } en ${props?.sector}`,
    suject: `${props?.propertyType.replaceAll("/", "-o-")} en ${
      props?.bussinesType
    } en ${props?.sector}`,
    body: `${props?.propertyType.replaceAll("/", "-o-")} en ${
      props?.bussinesType
    } en ${props?.sector} \n `
  };

  const onRedirectCustomWhatsApp = () => {
    const urlWhatsapp = `https://wa.me/?text=${encodeURIComponent(
      `${data.title} ${data.url}`
    )}`;

    window.open(urlWhatsapp, "_blank");
  };

  const itemSocial = [
    {
      icon: <EmailShareBtn url={data.url} subject={data.suject} body={data.body} />
    },
    {
      icon: <FBShareBtn url={data.url} quote="REMAX/RD" />
    },
    {
      icon: <TwitterShareBtn url={data.url} title={data.title} />
    },
    {
      icon: (
        <WhatsAppIconBtn onClick={onRedirectCustomWhatsApp}>
          {" "}
          <WhatsAppIcon />{" "}
        </WhatsAppIconBtn>
      )
    },
    {
      icon: <TelegramShareBtn url={data.url} title={data.title} />
    }
  ];
  return (
    <MenuOptions row={3} items={itemSocial}>
      {props.children}
    </MenuOptions>
  );
};

export default MenuSocial;

const WhatsAppIconBtn = styled(IconButton)`
  svg {
    width: 30px;
    height: 30px;
  }
`;
